import { ServiceFeePayer } from '@/apis/payments/service_fee.schema'
import { createPurseFormSchema } from '@/app/pages/providers/pages/choose_purses/choose_purses.schema'
import { PursesArray } from '@/schemas/provider.schema'
import { SelectedPurse } from '@/storage/applications/providerPaySlice'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { getTotalAmountToBePaidByApplicant } from '../../payment.utils'
import { PurseFormData } from './purse_allocation_form'

interface Props {
  apiPurses: PursesArray
  totalAmount: number
  baseAmount: number
  serviceFee: number
  serviceFeePayer: ServiceFeePayer
  selectedPurses: SelectedPurse[]
  customSchema?: z.ZodType<PurseFormData>
}

function usePurseAllocationForm(props: Props) {
  const {
    apiPurses,
    baseAmount,
    totalAmount,
    serviceFee,
    serviceFeePayer,
    selectedPurses,
    customSchema,
  } = props

  const totalApplicantAmount = getTotalAmountToBePaidByApplicant({
    base_amount: baseAmount,
    net_amount: totalAmount,
    serviceFeePayer: serviceFeePayer,
    service_fee: serviceFee,
  })

  const schema =
    customSchema ?? createPurseFormSchema(apiPurses, totalApplicantAmount)

  const defaultValues: PurseFormData = {
    purses: apiPurses.map((purse) => {
      const existingPurse = selectedPurses.find((p) => p.purse_id === purse.id)
      if (existingPurse) {
        return {
          ...existingPurse,
        }
      } else {
        return {
          amount: 0.0,
          isSelected: false,
          purse_id: purse.id,
          name: purse.name,
          hasBeenManuallyEdited: false,
        }
      }
    }),
  }

  const methods = useForm<PurseFormData>({
    resolver: zodResolver(schema),
    defaultValues: defaultValues,
  })

  function getSelectedPurses() {
    const selectedPurses = methods
      .getValues()
      .purses.filter((purse) => purse.isSelected)
    return selectedPurses
  }

  return {
    methods,
    totalApplicantAmount,
    getSelectedPurses,
  }
}

export default usePurseAllocationForm
